/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_ContactAddressDTO } from '../models/Routemize_DTOs_ContactAddressDTO';
import type { Routemize_DTOs_CreateContactAddressDTO } from '../models/Routemize_DTOs_CreateContactAddressDTO';
import type { Routemize_DTOs_UpdateContactAddressDTO } from '../models/Routemize_DTOs_UpdateContactAddressDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactAddressService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ContactAddressDTO OK
     * @throws ApiError
     */
    public static postApiAppContactAddressCreate(
        requestBody?: Routemize_DTOs_CreateContactAddressDTO,
    ): CancelablePromise<Routemize_DTOs_ContactAddressDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/contactAddress/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppContactAddressDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/contactAddress/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_ContactAddressDTO OK
     * @throws ApiError
     */
    public static getApiAppContactAddressGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_ContactAddressDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/contactAddress/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param contactId
     * @returns Routemize_DTOs_ContactAddressDTO OK
     * @throws ApiError
     */
    public static getApiAppContactAddressGetContactAddresses(
        contactId: string,
    ): CancelablePromise<Array<Routemize_DTOs_ContactAddressDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/contactAddress/getContactAddresses/{contactId}',
            path: {
                'contactId': contactId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ContactAddressDTO OK
     * @throws ApiError
     */
    public static putApiAppContactAddressUpdate(
        requestBody?: Routemize_DTOs_UpdateContactAddressDTO,
    ): CancelablePromise<Routemize_DTOs_ContactAddressDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/contactAddress/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
